import { render, staticRenderFns } from "./x-tag-cloud.vue?vue&type=template&id=40dad938&scoped=true&"
import script from "./x-tag-cloud.vue?vue&type=script&lang=js&"
export * from "./x-tag-cloud.vue?vue&type=script&lang=js&"
import style0 from "./x-tag-cloud.vue?vue&type=style&index=0&id=40dad938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dad938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40dad938', component.options)
    } else {
      api.reload('40dad938', component.options)
    }
    module.hot.accept("./x-tag-cloud.vue?vue&type=template&id=40dad938&scoped=true&", function () {
      api.rerender('40dad938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-tag-cloud.vue"
export default component.exports